import React from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

function DesktopMainNav({ mainMenu, klassName }) {
  const { makeStyles } = useUiContext();

  const useStyles = makeStyles((theme) => ({
    list: {
      display: 'flex',
      gap: theme.spacing(3),
      padding: 0,
      margin: 0,
      listStyle: 'none',
    },
    listItem: {
      margin: 0,
    },
    link: {
      padding: theme.spacing(1, 2),
      fontSize: '0.875rem',
      display: 'inline-block',
      textTransform: 'uppercase',
      textDecoration: 'none',
    },
    underline: {
      textDecoration: 'underline',
    }
  }));

  const styles = useStyles();

  const stringParameterize = (str) =>
    str.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/g, '').replace(/\s+/g, '-');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.target.click();
    }
  };

  const addUnderline = (name) => name == 'book-an-appointment' ? 'underline' : ''

  return (
    <nav className={`main-nav nav-${klassName}`} aria-label={`${klassName} Navigation`}>
      <ul className={styles.list}>
        {mainMenu.map((item) => (
          <li key={item.name} className={styles.listItem}>
            <a
              href={item.url}
              tabIndex={0}
              className={`${styles.link} top-level-link top-level-link--${stringParameterize(item.name)} ${addUnderline(stringParameterize(item.name))}`}
              onKeyDown={handleKeyDown}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default DesktopMainNav;
